/* global  */ // tUrl等のグローバル変数を宣言する
import scrollLock from './functions/_scrollLock.js' // スクロールロック
import 'core-js/features/number/is-nan' // SwiperのIE対応
import 'custom-event-polyfill' // SwiperのIE対応
import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

/*
 ######  ##       #### ########  ########
##    ## ##        ##  ##     ## ##
##       ##        ##  ##     ## ##
 ######  ##        ##  ##     ## ######
      ## ##        ##  ##     ## ##
##    ## ##        ##  ##     ## ##
 ######  ######## #### ########  ########
*/
if (document.getElementById('topMv')) {
  // Swiperコンテナを検出したら実行
  const slideItem = document.getElementById('topMv')
  const sliderName = 'topMv'
  // eslint-disable-next-line no-unused-vars
  const topMvSwiper = new Swiper(slideItem, {
    // init: false, // 自動で初期化しない（topMvSwiper.init()で初期化）
    effect: 'slide', // slide,fade,cube,coverflow
    speed: 1500, // アニメ速度
    loop: true, // ループ
    // loopAdditionalSlides: 10, //ループ演出用のクローン数を増やして安定化させる
    preloadImages: false, // スライド内の画像を読み終えてから開始

    centeredSlides: true, // 中央のスライドを基準にする
    // freeMode: true, //ドラッグ等でのスライド時、スライドが定位置以外で止まれるようにする
    // grabCursor: true, // 掴みカーソル
    // simulateTouch: false, // マウスドラッグでスワイプ操作　無効でテキスト選択が可能に
    // autoHeight: true, // スライドごとに高さを変動させる

    autoplay: {
      // オートオプション
      delay: 7000, // 待機時間
      disableOnInteraction: false, // 操作されたらオート解除
    },
    navigation: {
      nextEl: '.swiper-button-next--' + sliderName, // 前のページボタンを呼び出す要素
      prevEl: '.swiper-button-prev--' + sliderName, // 次のページボタンを呼び出す要素
    },
    pagination: {
      // ページャーオプション
      el: '.swiper-pagination--' + sliderName, // ページャーを呼び出す要素
      type: 'bullets', // bullets,fraction(現ページ/ページ数),progressbar,custom
      clickable: true, // クリックでジャンプ可能にする
      //   renderBullet: function(index, className) {
      //     // bulletsの描画内容を改変
      //     const targetImage = $('[data-swiper-slide-index="' + index + '"]')
      //       .find("img")
      //       .attr("src");
      //     return (
      //       '<div class="' +
      //       className +
      //       '"><img src=" ' +
      //       targetImage +
      //       ' " alt="ページ' +
      //       index +
      //       '" /></div>'
      //     );
      //   },
    },
    breakpoints: {
      // 指定px以上でオプション切り替え
      901: {
        slidesPerView: 3, //表示数変更
      },
    },
  })
}

/*
#### ##    ## ########          #######  ########   ######
 ##  ####  ##    ##            ##     ## ##     ## ##
 ##  ## ## ##    ##    ####### ##     ## ########   ######
 ##  ##  ####    ##            ##     ## ##     ##       ##
#### ##    ##    ##             #######  ########   ######
*/
// 画面に入った監視対象に.animatedを付加
// Intersection Observer
if (document.getElementsByClassName('js-in')[0]) {
  intObs()
}
function intObs() {
  const intObsOption = {
    // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
    rootMargin: '-20px 0px', // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
    threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
  }
  const observer = new IntersectionObserver(intObsCallback, intObsOption)
  const intObsItems = document.getElementsByClassName('js-in')
  for (let index = 0; index < intObsItems.length; index++) {
    const intObsItem = intObsItems[index]
    observer.observe(intObsItem) // 監視対象に加える
  }
  function intObsCallback(entries) {
    for (let index = 0; index < entries.length; index++) {
      const entry = entries[index]
      if (entry.isIntersecting) {
        const entryItem = entry.target
        entryItem.classList.add('animated')
        observer.unobserve(entryItem) // 監視対象から外す
      }
    }
  }
}

/*
########  #######   ######    ######   ##       ########
   ##    ##     ## ##    ##  ##    ##  ##       ##
   ##    ##     ## ##        ##        ##       ##
   ##    ##     ## ##   #### ##   #### ##       ######
   ##    ##     ## ##    ##  ##    ##  ##       ##
   ##    ##     ## ##    ##  ##    ##  ##       ##
   ##     #######   ######    ######   ######## ########
*/
if (document.getElementsByClassName('js-toggleView')[0]) {
  window.addEventListener('click', function (e) {
    if (!e.target.classList.contains('js-toggleView')) {
      return
    }
    e.preventDefault() // デフォルトのイベントを除去
    const group = e.target.dataset.toggleGroup
    const target = e.target.dataset.toggleTarget
    toggleView(group, target)
  })
}
function toggleView(group, target) {
  const hide = document.getElementsByClassName('js-toggleView-group--' + group)
  for (let index = 0; index < hide.length; index++) {
    hide[index].classList.remove('active')
  }
  const view = document.getElementsByClassName('js-toggleView-target--' + target)
  for (let index = 0; index < view.length; index++) {
    view[index].classList.add('active')
  }
}

/*
 ######   ######  ########   #######  ##       ##
##    ## ##    ## ##     ## ##     ## ##       ##
##       ##       ##     ## ##     ## ##       ##
 ######  ##       ########  ##     ## ##       ##
      ## ##       ##   ##   ##     ## ##       ##
##    ## ##    ## ##    ##  ##     ## ##       ##
 ######   ######  ##     ##  #######  ######## ########
*/
/**
 * @function scrollValToggle
 * @description スクロール量を基準にクラスを着脱する
 * @param {String} targetSelector ターゲットとする一意なセレクタ
 * @param {Number} scrollValStart 有効範囲となるスクロール量　上からの距離
 * @param {Number|Boolean} [scrollValEnd=false] 有効範囲外となるスクロール量　下からの距離
 * @param {String} toggleClass 切り替えるクラス名
 * @return {Void}
 * scrollValToggle('#hogeID', 500, false,'active')
 */
scrollValToggle('#pagetop', 500, false, 'active')
function scrollValToggle(targetSelector, scrollValStart = 500, scrollValEnd = false, toggleClass = 'active') {
  if (!document.querySelector(targetSelector)) {
    return
  }
  let isExecute = false // 実行中フラグ
  let scrollY = 0 // 縦方向のスクロール量
  const target = document.querySelector(targetSelector) // ターゲット要素
  let scToggleActive = false // ターゲット要素のONOFF状態
  document.addEventListener('scroll', function (ev) {
    scrollValToggleApply()
  })
  scrollValToggleApply() // 初回起動
  function scrollValToggleApply() {
    if (isExecute) {
      // 実行中ならスキップ
      return
    }
    isExecute = true
    // レンダリング準備が整ったら開始
    requestAnimationFrame(function () {
      scrollY = window.pageYOffset // スクロール量
      if (scrollY >= scrollValStart && !scToggleActive) {
        //トップから指定px以上スクロールしたらON
        target.classList.add(toggleClass)
        scToggleActive = true
      } else if (scrollY < scrollValStart && scToggleActive) {
        //スクロールが足りない時はOFF
        target.classList.remove(toggleClass)
        scToggleActive = false
      }
      if (scrollValEnd && scToggleActive) {
        // 終了ラインが設定されている場合は終了判定
        if (scrollY + window.innerHeight > document.documentElement.offsetHeight - scrollValEnd) {
          //スクロール終了範囲を過ぎていたらOFF
          target.classList.remove(toggleClass)
          scToggleActive = false
        }
      }
      isExecute = false
    })
  }
}

/*
 ######  ########    ###    ########   ######  ##     ##
##    ## ##         ## ##   ##     ## ##    ## ##     ##
##       ##        ##   ##  ##     ## ##       ##     ##
 ######  ######   ##     ## ########  ##       #########
      ## ##       ######### ##   ##   ##       ##     ##
##    ## ##       ##     ## ##    ##  ##    ## ##     ##
 ######  ######## ##     ## ##     ##  ######  ##     ##
*/
const spSearchBtn = document.getElementById('sp-search-open')
const spSearch = document.getElementById('sp-search')
const spMenuBtn = document.getElementById('sp-menu-open')
const spMenu = document.getElementById('sp-menu')
const overlay = document.getElementById('overlay')

spSearchBtn.addEventListener('click', function (e) {
  // 指定のクラスを持つ
  if (e.target.classList.contains('active')) {
    spSearchClose()
  } else {
    spSearchOpen()
  }
})
overlay.addEventListener('click', function (e) {
  spSearchClose()
})
spMenuBtn.addEventListener('click', function (e) {
  spSearchClose(false)
})

function spSearchOpen(overlaySwitch = true) {
  spSearchBtn.classList.add('active')
  spSearch.classList.add('active')
  spMenuBtn.classList.remove('active')
  spMenu.classList.remove('active')
  if (overlaySwitch) {
    overlay.classList.add('active')
    scrollLock('body', '#overlay')
  }
}
function spSearchClose(overlaySwitch = true) {
  spSearchBtn.classList.remove('active')
  spSearch.classList.remove('active')
  if (overlaySwitch) {
    overlaySwitch.classList.remove('active')
    scrollLock('body', '#overlay')
  }
}

/*
########  #######  ########  ##     ##          ######  ##     ## ########  ######  ##    ##
##       ##     ## ##     ## ###   ###         ##    ## ##     ## ##       ##    ## ##   ##
##       ##     ## ##     ## #### ####         ##       ##     ## ##       ##       ##  ##
######   ##     ## ########  ## ### ## ####### ##       ######### ######   ##       #####
##       ##     ## ##   ##   ##     ##         ##       ##     ## ##       ##       ##  ##
##       ##     ## ##    ##  ##     ##         ##    ## ##     ## ##       ##    ## ##   ##
##        #######  ##     ## ##     ##          ######  ##     ## ########  ######  ##    ##
*/

// 問い合わせフォーム
// チェック内容に応じて入力欄を表示する
// radio01　お問い合わせ内容
// radiosub02　「協力会社について」サブ項目
window.addEventListener('change', function (e) {
  if (e.target.name === 'radio01' || e.target.name === 'radiosub02') {
    checkHide()
  }
})

if (document.getElementById('radio01-1') || document.querySelector('[name="radio01"]')) {
  checkHide()
}

function checkHide() {
  // すべてを非アクティブにする
  const hideList = document.getElementsByClassName('js-hideInput')
  for (let index = 0; index < hideList.length; index++) {
    hideList[index].classList.remove('active')
  }

  // 協力会社についてにチェックがある場合のみアクティブ処理を行う
  if (!valueCheck('radio01', '協力会社について')) {
    return
  }

  // 「協力会社について」のサブ項目にチェックがある場合のみアクティブ処理を行う
  let targetName = ''

  if (valueCheck('radiosub02', '販売代理店募集')) {
    targetName = 'store'
  } else if (valueCheck('radiosub02', '施工業者募集')) {
    targetName = 'company'
  } else {
    return
  }

  // 指定の入力欄をアクティブにする
  const viewList = document.getElementsByClassName('js-hideInput--' + targetName)
  for (let index = 0; index < viewList.length; index++) {
    viewList[index].classList.add('active')
  }
}

function valueCheck(name, value) {
  const check = document.querySelector('[name="' + name + '"][value="' + value + '"]')
  if (check && check.checked) {
    return true
  }
  const hidden = document.querySelector('[name="' + name + '"][type="hidden"]')
  if (hidden && hidden.value === value) {
    return true
  }
  return false
}
